import { createPortal } from "react-dom";

export default function TipperPortal(props) {
  const portalRoot = document.getElementById("tipper-portal");
  return createPortal(props.children, portalRoot);
}
